export default "__VITE_ASSET__CHoeBGM5__"